import ImportZimsContentCard from "../specific/ImportZimsContentCard";
import ImportTrainingContentCard from "../specific/ImportTrainingContentCard";
import ImportObservationGridContentCard from "../specific/ImportObservationGridContentCard";

const contentMapping: { [key: string]: any } = {
  zims: ImportZimsContentCard,
  observationGrid: ImportObservationGridContentCard,
  training: ImportTrainingContentCard,
};

export default contentMapping;
